// extracted by css-extract-rspack-plugin
export default {"aliceAppTitle__container":"aliceAppTitle__container__y3lkC","aliceAppTitle__header":"aliceAppTitle__header__lQdFa","aliceAppTitle_hideAtMobile":"aliceAppTitle_hideAtMobile__YoZ6V"};